import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGet } from "hooks/fetch/useFetchGet";

export function useGetMinMaxTagsMachines(
  machineIds: number[],
  tagIds: number[]
): {
  loading: boolean;
  error: boolean;
  range: { min_date: string; max_date: string } | undefined;
} {
  const url = useMemo(
    () =>
      `scalars_hi/date_range` +
      makeQueryString({
        machines: machineIds,
        tags: tagIds
      }),
    [machineIds, tagIds]
  );

  const { loading, error, response } = useFetchGet(
    url,
    machineIds.length === 0 || tagIds.length === 0
  );

  return {
    loading,
    error,
    range: response
  };
}
